import { EventEmitter } from "events"
import dispatcher from "../dispatcher"
import { IAvailablePositions, IEditablePunchData, IEquipmentDocument, IJobDocument, IPosition, IPunchPositionDocument, IScheduleShift } from "../models"

class EditablePunchTableDataStore extends EventEmitter {
    punchPositionDocuments: IPunchPositionDocument[]
    jobs: IJobDocument[]
    equipments: IEquipmentDocument[]
    shifts: IScheduleShift[]
    availablePositions: IAvailablePositions[]
    constructor() {
        super()
        this.setMaxListeners(0)
        this.punchPositionDocuments = []
        this.jobs = []
        this.equipments = []
        this.shifts = []
        this.availablePositions = []
    }

    initEditablePunchData() {
        this.punchPositionDocuments = []
        this.jobs = []
        this.equipments = []
        this.shifts = []
        this.availablePositions = []
    }

    receiveUserEditablePunchData(data: IEditablePunchData) {
        const punchPositionDocuments = []
        data.PunchBundles.forEach(i => i.PunchPosition && punchPositionDocuments.push(i.PunchPosition))
        this.punchPositionDocuments = punchPositionDocuments
        this.jobs = data.Jobs
        this.equipments = data.Equipments
        this.shifts = data.Shifts
        this.availablePositions = data.AvailablePositions
    }

    addJob(job: IJobDocument) {
        this.jobs.push(job)
    }

    getJob(jobId: string): IJobDocument {
        return this.jobs.find(i => i.Id === jobId)
    }

    addEquipment(equipment: IEquipmentDocument) {
        this.equipments.push(equipment)
    }

    getEquipment(equipmentId: string): IEquipmentDocument {
        return this.equipments.find(i => i.Id === equipmentId)
    }

    addShift(shift: IScheduleShift) {
        this.shifts.push(shift)
    }

    getShift(shiftId: string): IScheduleShift {
        return this.shifts.find(i => i.Id === shiftId)
    }

    addAvailablePositions(availablePosition: IAvailablePositions) {
        this.availablePositions.push(availablePosition)
    }

    getAvailablePosition(userId: string, shiftId: string, hierarchyId: string, jobId: string, phaseId: string): IPosition[] {
        var storedData = this.availablePositions.find(i => i.UserId === userId && i.ShiftId === shiftId && i.HierarchyId === hierarchyId && i.JobId === jobId && i.PhaseId === phaseId)
        return storedData ? storedData.Positions : null
    }

    getPunchPositionDocument(punchId: string): IPunchPositionDocument {
        return this.punchPositionDocuments.find(i => i.Id === punchId)
    }

    handleActions(action) {
        switch (action.type) {
        }
    }
}

const editablePunchTableDataStore = new EditablePunchTableDataStore()
dispatcher.register(editablePunchTableDataStore.handleActions.bind(editablePunchTableDataStore))
export default editablePunchTableDataStore
